import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/activity/time-entry/category/query/', 'Time category');

tbl.add(new Xtc('name', 'Name'))
tbl.add(new Xtc('rate', 'Rate').renderSlot('rate'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

